import { Box, CircularProgress, Input, Modal, Typography } from "@mui/material"
import React, { useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import useStyles from "./useStyles"
import { enabledBasicME } from "../../../../../redux/actions/Instances"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
} from "../../../../../redux/actions/app"
import DateRangeIcon from "@mui/icons-material/DateRange"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { es } from "date-fns/locale"
import { initializeAppInstanceModules } from "../../../../../utils/traducTypes"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 550,
  bgcolor: "white",
  p: 3,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
}

export const BasicEnabledME = ({
  openModal,
  handleClose,
  organization = null,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [MaxFirmStaffCount, setMaxFirmStaffCount] = useState("50")
  const [MaxFirmCustomerCount, setMaxFirmCustomerCount] = useState("75")
  const [MaxFirmCustomerStaffCount, setMaxFirmCustomerStaffCount] =
    useState("2")
  const [MaxCapacityGB, setMaxCapacityGB] = useState("25")
  const [MaxFirmCustomerVECount] = useState("0")

  const [MaxFirmStaffCounterror, setMaxFirmStaffCounterror] = useState(false)
  const [MaxFirmCustomerCountError, setMaxFirmCustomerCountError] =
    useState(false)
  const [MaxFirmCustomerStaffCountError, setMaxFirmCustomerStaffCountError] =
    useState(false)
  const [MaxCapacityGBError, setMaxCapacityGBError] = useState(false)
  const [MaxFirmCustomerVECountError, setMaxFirmCustomerVECountError] =
    useState(false)
  const [errortext, seterrortext] = useState(false)
  const [errortextValue, seterrortextValue] = useState(
    "Complete todos los datos",
  )
  const [errortextVE, seterrortextVE] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date("2099-12-31"))

  const handleDateChange = (date) => {
    seterrortext(false)
    setSelectedDate(date)
  }

  const onChangeMaxFirmStaffCount = (event) => {
    seterrortext(false)

    if (event.target.value === "") return setMaxFirmStaffCount("0")

    if (event.target.value === "0" || parseInt(event.target.value))
      setMaxFirmStaffCount(parseInt(event.target.value))
  }

  const onChangeMaxFirmCustomerCount = (event) => {
    seterrortext(false)

    if (event.target.value === "") return setMaxFirmCustomerCount("0")
    if (event.target.value === "0" || parseInt(event.target.value))
      setMaxFirmCustomerCount(parseInt(event.target.value))
  }

  const onChangeMaxFirmCustomerStaffCount = (event) => {
    seterrortext(false)

    if (event.target.value === "") return setMaxFirmCustomerStaffCount("0")
    if (event.target.value === "0" || parseInt(event.target.value))
      setMaxFirmCustomerStaffCount(parseInt(event.target.value))
  }

  const onChangeMaxCapacityGB = (event) => {
    seterrortext(false)

    if (event.target.value === "") return setMaxCapacityGB("0")

    if (event.target.value === "0" || parseInt(event.target.value))
      setMaxCapacityGB(parseInt(event.target.value))
  }

  const onChangeMaxFirmCustomerVECount = (event) => {
    // seterrortext(false)

    // if (event.target.value === "") return setMaxFirmCustomerVECount("0")
    // if (event.target.value === "0" || parseInt(event.target.value))
    //   setMaxFirmCustomerVECount(parseInt(event.target.value))
  }

  const isValidate = () => {
    setMaxFirmStaffCounterror(false)
    setMaxFirmCustomerCountError(false)
    setMaxFirmCustomerStaffCountError(false)
    setMaxCapacityGBError(false)
    setMaxFirmCustomerVECountError(false)
    seterrortext(false)
    seterrortextVE(false)
    seterrortextValue("* Complete todos los datos")
    if (MaxFirmStaffCount === "") {
      seterrortext(true)
      setMaxFirmStaffCounterror(true)
      return false
    }
    if (MaxFirmCustomerCount === "") {
      seterrortext(true)
      setMaxFirmCustomerCountError(true)

      return false
    }
    if (MaxFirmCustomerStaffCount === "") {
      seterrortext(true)
      setMaxFirmCustomerStaffCountError(true)

      return false
    }
    if (MaxCapacityGB === "") {
      seterrortext(true)
      setMaxCapacityGBError(true)

      return false
    }
    if (MaxFirmCustomerVECount === "") {
      seterrortext(true)
      setMaxFirmCustomerVECountError(true)

      return false
    }
    if (MaxFirmCustomerVECount > MaxFirmCustomerCount) {
      seterrortextVE(true)
      setMaxFirmCustomerVECountError(true)
      setMaxFirmCustomerCountError(true)
      return false
    }
    if (!selectedDate) {
      seterrortext(true)
      return false
    }
    if (selectedDate < new Date()) {
      seterrortextValue(
        "* Seleccione una fecha de vencimiento posterior al día de hoy",
      )

      seterrortext(true)
      return false
    }
    return true
  }
  const handleEnabledME = async () => {
    setShowCircularProgress(true)
    if (isValidate()) {
      const accessStartDate = new Date().toISOString().split("T")[0]
      const accessFinishDate = selectedDate.toISOString().split("T")[0]
      console.log(organization)
      if (organization) {
        await dispatch(
          enabledBasicME({
            organizationId: organization.organizationId,
            suborganizationName: organization.organizationName,
            suborganizationLegalName: organization.organizationName,
            suborganizationCUIT: organization.organizationCuit,
            appParams: [
              {
                appParameterCode: "User.MaxFirmStaffCount",
                parameterValue: MaxFirmStaffCount,
                productParameterRefCode: "ME.USER.MAX-FIRM-STAFF-COUNT",
              },
              {
                appParameterCode: "FirmCustomer.MaxFirmCustomerCount",
                parameterValue: MaxFirmCustomerCount,
                productParameterRefCode: "ME.FIRM-CUSTOMER.MAX-FIRM-CUSTOMER-COUNT",
              },
              {
                appParameterCode: "User.MaxFirmCustomerStaffCount",
                parameterValue: MaxFirmCustomerStaffCount,
                productParameterRefCode: "ME.USER.MAX-FIRM-CUSTOMER-STAFF-COUNT",
              },
              {
                appParameterCode: "Storage.MaxCapacityGB",
                parameterValue: MaxCapacityGB,
                productParameterRefCode: "ME.STORAGE.MAX-CAPACITY-GB",
              },
              {
                appParameterCode: "CommunicationVE.MaxFirmCustomerCount",
                parameterValue: 0,
                productParameterRefCode: null
              },
            ],
            accessStartDate: new Date().toISOString().split("T")[0],
            accessFinishDate: selectedDate.toISOString().split("T")[0],
            appModules: initializeAppInstanceModules.map((m) => {
              return {
                appModuleCode: m,
                startDate: accessStartDate,
                finishDate: accessFinishDate,
              }
            }),
          }),
        )
        setTimeout(() => {
          handleClose()
          navigate(0)
        }, 5000)
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ha ocurrido un error. Intente recargar la página.",
          ),
        )
      }
    }

    setShowCircularProgress(false)
  }

  function ButtonConfirm({ showCircularProgress, handleEnabledME }) {
    const classes = useStyles()

    return (
      <button className={classes.confirmButton}>
        {showCircularProgress ? (
          <CircularProgress size="1.5rem" color="inherit" />
        ) : (
          <Typography
            className={classes.confirmButtonTypography}
            variant="contained"
            onClick={handleEnabledME}
          >
            Habilitar ME
          </Typography>
        )}
      </button>
    )
  }

  function ButtonClose({ handleClose }) {
    const classes = useStyles()

    return (
      <Box onClick={handleClose} className={classes.closeButton}>
        <Typography className={classes.closeButtonColor}>Cancelar</Typography>
      </Box>
    )
  }

  return (
    <>
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <CloseIcon
              sx={{
                fontSize: "medium",
                color: "#263057",
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </div>

          <div>
            <Typography
              sx={{
                color: "#263057",
                fontSize: "1.3em",
                fontWeight: 700,
                display: "flex",
                justifyContent: "center",
              }}
            >
              Habilitación de Mi Estudio Básico
            </Typography>
          </div>
          <Typography
            sx={{
              color: "#263057",
              fontFamily: "Roboto",
              marginTop: '25px',
              fontWeight: 700,
              fontSize: "1.1em",
            }}
          >
            Configure los Topes:
          </Typography>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.typographyStyle}>
              Cantidad Máxima de Usuarios Colaboradores (incluido admin):
            </Typography>
            <Input
              name={"MaxFirmCustomerStaffCount"}
              size="small"
              variant="standard"
              value={MaxFirmCustomerStaffCount}
              onChange={onChangeMaxFirmCustomerStaffCount}
              inputProps={{ style: { textAlign: "center" } }}
              className={classes.inputStyle}
              error={MaxFirmCustomerStaffCountError}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.typographyStyle}>
              Cantidad Máxima Clientes de Estudio:
            </Typography>
            <Input
              name={"MaxFirmStaffCount"}
              size="small"
              variant="standard"
              value={MaxFirmStaffCount}
              onChange={onChangeMaxFirmStaffCount}
              inputProps={{ style: { textAlign: "center" } }}
              className={classes.inputStyle}
              error={MaxFirmStaffCounterror}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.typographyStyle}>
              Cantidad Máxima Colaboradores de Clientes Estudio:
            </Typography>
            <Input
              name={"MaxFirmCustomerCount"}
              size="small"
              variant="standard"
              value={MaxFirmCustomerCount}
              onChange={onChangeMaxFirmCustomerCount}
              inputProps={{ style: { textAlign: "center" } }}
              className={classes.inputStyle}
              error={MaxFirmCustomerCountError}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.typographyStyle}>
              Capacidad de Almacenaje Storage (GB)
            </Typography>
            <Input
              name={"MaxCapacityGB"}
              size="small"
              variant="standard"
              value={MaxCapacityGB}
              onChange={onChangeMaxCapacityGB}
              inputProps={{ style: { textAlign: "center" } }}
              className={classes.inputStyle}
              error={MaxCapacityGBError}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Typography className={classes.typographyStyle}>
              Cantidad Máxima Clientes Módulo e-Ventanilla
            </Typography>
            <Input
              name={"MaxFirmCustomerVECount"}
              size="small"
              variant="standard"
              value={MaxFirmCustomerVECount}
              onChange={onChangeMaxFirmCustomerVECount}
              inputProps={{ style: { textAlign: "center" } }}
              className={classes.inputStyle}
              error={MaxFirmCustomerVECountError}
            />
          </div>
    
            <Typography
              style={{
                color: "#263057",
                margin: '15px 0px',
              }}
            >
              Seleccione la fecha de vencimiento:
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <DateRangeIcon sx={{ color: "#263057", fontSize: "2em" }} />
              <div style={{ width: "70%", paddingLeft: 5 }}>
                <div style={{ display: "flex" }}>
                  <Typography sx={{ color: "#263057", width: "20%" }}>
                    Hasta:
                  </Typography>
                  <div
                    style={{
                      width: "70%",
                    }}
                  >
                    <DatePicker
                      id="date"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/mm/aaaa"
                      showYearDropdown
                      scrollableYearDropdown
                      locale={es}
                    />
                  </div>
                </div>
              </div>
            </div>
      
          {errortext && (
            <div
              style={{
                color: "red",
                fontFamily: "Roboto",
                marginTop: "5%",
                fontWeight: 700,
                fontSize: "1.1em",
              }}
            >
              {errortextValue}
            </div>
          )}
          {errortextVE && (
            <div
              style={{
                color: "red",
                fontFamily: "Roboto",
                marginTop: "5%",
                fontWeight: 700,
                fontSize: "1.1em",
              }}
            >
              La cantidad máxima colaboradores de clientes de Estudio debe ser
              menor o igual a la cantidad máxima de clientes del módulo
              e-Ventanilla
            </div>
          )}
          <Box className={classes.buttons} style={{ marginLeft: "45%" }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              handleEnabledME={handleEnabledME}
            />

            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
